import { httpGet, httpPost } from "@eres/rest";
import appConfig from "./config";
import { ProjectProperty } from "@eres/ejari-api/Entity/LeasedProperties";
import { checkApiRequestResponseError } from "@eres/ejari-api/Utils";
import { AddPropertyError, AddPropertyErrorResponse, AddPropertyResponse, RegisterPropertyRequest } from "./entities";
import { isEmptyStringOrNull } from "@eres/core/dist/StringUtils";
import I8N from "@eres/core/dist/I8N";

export function getLandProperties( lPropertyId?: number, partId?: number ): Promise<ProjectProperty[]> {
	return httpGet( appConfig.addPropertyAPI().endPoint() +
		`api/Properties/GetLandProperties?landPropertyId=${ lPropertyId }&participantId=${ partId }&propertyNumber=&dmNo=&dmSubNo=&areaId=&startIndex=0&maxRows=0` )
	.then( checkApiRequestResponseError ).then( ( resp: any ) => {
		return resp ?? [];
	} );
}

export function registerProperty( request: RegisterPropertyRequest ) {
	return httpPost( appConfig.addPropertyAPI().endPoint() + `api/PublicCertificate/RegisterProperty`, request ).then( r => {
		return validateResponse( r );
	} );
}

function validateResponse<T extends AddPropertyErrorResponse>( response: AddPropertyResponse<T> ): Promise<T> {
	if ( response == undefined || response.Response == undefined ) {
		return Promise.reject( "Empty response" );
	} else if ( response.Response.ServiceValidationErrors && response.Response.ServiceValidationErrors.length > 0 ) {
		const errorMsg = getValidationError( response.Response.ServiceValidationErrors );
		if ( !isEmptyStringOrNull( errorMsg ) ) {
			return Promise.reject( errorMsg );
		}
		return Promise.resolve( response.Response );
	}
	return Promise.resolve( response.Response );
}

function getValidationError( errors: AddPropertyError[] ) {
	let errorMsg = "";
	errors.forEach( ( error: AddPropertyError ) => {
		if ( error.ErrorEnumCode !== "1" ) {
			let nameEn = !isEmptyStringOrNull( error.ErrorDescEn ) ? error.ErrorDescEn : error.ErrorDescAr;
			let nameAr = !isEmptyStringOrNull( error.ErrorDescAr ) ? error.ErrorDescAr : error.ErrorDescEn;
			errorMsg += `${ I8N.isRTL() ? nameAr : nameEn }\n`;
		}
	} );
	return errorMsg.trim();
}
